import { Vector } from "p5";

class Wiper {
  brushSize: number;
  color: string;
  index: number;
  p: any;

  // Vectors
  location: Vector;
  velocity: any;

  isActive: boolean;

  springConstant: number;
  damp: number;

  velx: number;
  vely: number;
  accel: number;
  force: number;

  amplitude: number;

  constructor(color: string, p: any, index: number) {
    this.p = p;
    this.location = p.createVector(this.p.mouseX, this.p.mouseY);
    this.index = index;
    this.isActive = true;

    this.brushSize = 25;
    this.color = color;

    this.springConstant = 0.1;
    this.damp = 0.9;

    this.amplitude = 0;
    this.velx = 0.0; // X Velocity
    this.vely = 0.0; // Y Velocity
    this.accel = 0; // Acceleration
    this.force = 0;
  }

  setActive() {
    this.isActive = true;
  }

  setInactive() {
    this.isActive = false;
  }

  setBrushColor(color: string) {
    this.color = color;
  }

  setBrushSize(size: number) {
    this.brushSize = size;
  }

  getLocation() {
    return this.location;
  }

  setAmplitude(a: number) {
    this.amplitude = a;
  }

  springX(x: number) {
    this.force = -0.1 * (this.location.x - x); // f=-ky
    this.accel = this.force / 10; // Set the acceleration, f=ma == a=f/m
    this.velx = 0.9 * (this.velx + this.accel); // Set the velocity
    return this.location.x + this.velx; // Update
  }

  springY(y: number) {
    this.force = -0.1 * (this.location.y - y); // f=-ky
    this.accel = this.force / 10; // Set the acceleration, f=ma == a=f/m
    this.vely = 0.9 * (this.vely + this.accel); // Set the velocity
    return this.location.y + this.vely; // Update
  }

  wipeVertical(y: number, span: number, offset: number, mX: number) {
    const xOff = this.index * span;
    const x = this.springX(mX) + xOff;
    const xSin = (this.p.sin(y / (10 + this.index)) * this.amplitude) / 10;
    this.location.set(this.p.createVector(x + xSin - offset, y));
  }

  wipeHorizontal(x: number, span: number, offset: number, mY: number) {
    const yOff = this.index * span;
    const y = this.springY(mY) + yOff;
    const ySin = (this.p.sin(x / (10 + this.index)) * this.amplitude) / 10;
    this.location.set(this.p.createVector(x, y + ySin - offset));
  }
}

export default Wiper;
